import { useRecordContext, Button, useDataProvider, useNotify, useRefresh } from "react-admin";
import { DoctoralRankingStatus } from "utils/constants";
import { doctoralRequests } from "api/doctoralApi";
import SecuredComponent from "server/security/SecuredComponent";
import permissions from "app/permissions";
import FlagIcon from "@mui/icons-material/Flag";
import { Typography } from "@mui/material";
import ConfirmModal from "server/components/Modals/ConfirmModal";

const DoctoralGenerateRankingButton = ({ onDone }) => {
  const record = useRecordContext();
  const notify = useNotify();
  const refresh = useRefresh();
  const dataProvider = useDataProvider();

  const status = record?.status;

  if (!record || status === DoctoralRankingStatus.Approved) {
    return null;
  }

  const isDraft = status === DoctoralRankingStatus.Draft;

  // No try/catch: ConfirmModal notifies on error and stays open.
  const generateDraft = async () => {
    await dataProvider.customRequest(doctoralRequests.generateCampaignRankingDraft(record.id), null, "POST");
    notify("Успешно изготвено класиране", { type: "success" });
    onDone ? onDone() : refresh();
  };

  return (
    <SecuredComponent permission={permissions.canManageDoctoralCampaignRankings}>
      <ConfirmModal
        triggerButton={
          <Button
            label={isDraft ? "Повторно изготвяне" : "Изготвяне"}
            variant="contained"
            size="medium"
          >
            <FlagIcon />
          </Button>
        }
        titleContent={`${isDraft ? "Повторно изготвяне" : "Изготвяне"} на класиране`}
        onConfirm={generateDraft}
        saveTitle="Изготви"
        saveIcon={<FlagIcon />}
        closeTitle="Затвори"
      >
        <Typography sx={{ py: 2 }}>
          {`Сигурни ли сте, че искате да изготвите това класиране${isDraft ? " отново" : ""}?`}
        </Typography>
      </ConfirmModal>
    </SecuredComponent>
  );
};

export default DoctoralGenerateRankingButton;
